import { OptimizelyDecision, useDecision } from '@optimizely/react-sdk'

import { optimizelyFeatureFlags } from '../../../constants/optimizely'

type OptimizelyFeatureFlagsKey = keyof typeof optimizelyFeatureFlags;

type OptimizelyFeatureFlagsName = (typeof optimizelyFeatureFlags)[OptimizelyFeatureFlagsKey];

const useOptimizely = (
  featureFlag: OptimizelyFeatureFlagsName,
  autoUpdate?: boolean
): OptimizelyDecision => {
  const [featureFlagDecision] = useDecision(featureFlag, { autoUpdate: autoUpdate || true })

  return featureFlagDecision
}

export { useOptimizely }
